import React, { useEffect, Fragment, useState, useRef } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { showToast } from "../../../components/ToastifyNotification";
import { UncontrolledTooltip } from "reactstrap";
import { GetCities } from "../../../api/masters/cityAPI";
import { GetAreaById, UpdateArea } from "../../../api/masters/areaAPI";
import useKeyboardSubmit from "../../../hooks/useKeyboardSubmit";
import useEnterNavigation from "../../../hooks/useEnterNavigation";

// Validation schema using Yup
const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  cityId: yup.string().required("City is required")
});

const EditArea = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [cities, setCities] = useState([]);

  const { id } = useParams();

  const { register, handleSubmit, setValue, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

  const fetchCities = async () => {
    try {
      const response = await GetCities(); // Make sure login function returns token
      if (response.success) {
        setCities(response.data);
      } else {
        // setError(response.message);
        showToast("error", response.message);
      }
    } catch (error) {
      // setError(error); // Handle login errors
      showToast("error", error);
    }
  };

  const fetchData = async () => {
    try {
      const response = await GetAreaById(id); // Make sure login function returns token

      if (response.success) {
        setValue("name", response.data.name); // Set default values
        setValue("cityId", response.data.cityId);
      } else {
        // setError(response.message);
        showToast("error", response.message);
      }
    } catch (error) {
      // setError(error); // Handle login errors
      showToast("error", error);
    }
  };

  // Fetch existing data
  useEffect(
    () => {
      const loadData = async () => {
        try {
          dispatch({ type: "LOADER_START" });

          await fetchCities();
          await fetchData();
        } catch (error) {
          showToast("error", error);
        } finally {
          dispatch({ type: "LOADER_STOP" });
        }
      };

      loadData();
    },
    [id]
  );

  const onSubmit = async data => {
    try {
      dispatch({ type: "LOADER_START" });

      const response = await UpdateArea(id, data);
      if (response.success) {
        showToast("success", response.message);
      } else {
        showToast("error", response.message);
      }
    } catch (error) {
      showToast("error", error);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  const formRef = useRef(null);
  useKeyboardSubmit(handleSubmit, onSubmit);
  useEnterNavigation(formRef);

  return (
    <Fragment>
      <Breadcrumb parent="Area" title="Edit Area" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <h5>Edit Area</h5>
                  <Link to={`/masters/area/list`}>
                    <button className="btn btn-primary" id="list">
                      List Area
                    </button>
                    <UncontrolledTooltip placement="top" target="list">
                      List Area
                    </UncontrolledTooltip>
                  </Link>
                </div>
              </div>
              <form
                ref={formRef}
                className="form theme-form"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="name">Select City*</label>
                        <select
                          className="form-select"
                          id="name"
                          type="text"
                          {...register("cityId")}
                        >
                          <option value="">Select City</option>
                          {cities.map(city =>
                            <option value={city._id}>
                              {city.name}
                            </option>
                          )}
                        </select>
                        {errors.cityId &&
                          <p className="text-danger">
                            {errors.cityId.message}
                          </p>}
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="name">Area Name*</label>
                        <input
                          className="form-control"
                          id="name"
                          type="text"
                          placeholder="Area Name"
                          {...register("name")}
                        />
                        {errors.name &&
                          <p className="text-danger">
                            {errors.name.message}
                          </p>}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer text-end">
                  <button className="btn btn-primary me-2" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default EditArea;
